import { render, staticRenderFns } from "./AboutMyColor.vue?vue&type=template&id=fe7c539a&"
import script from "./AboutMyColor.vue?vue&type=script&lang=ts&"
export * from "./AboutMyColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports